module.exports = __webpack_public_path__ + "img/pamphlet--01@2x.49e9ef36.png";